<script>
	const { assetUrl } = require('utilities/urlUtilities');

	export default {
		modelData: ['userContext'],
		components: {
			'outbound-link': require('components/outbound-link.vue').default
		},
		computed: {
			logoSrc() {
				return assetUrl('/assets/dist/images/wordsmyth/ws_logo_32x32.gif');
			}
		}
	};
</script>
<template>
	<div class="wordsmyth-powered-by">
		<div v-if="userContext && userContext.classCode">
			<span class="_ws_pre_title">Powered by</span>
			<img
				:src="logoSrc"
				alt="WordSmyth Logo"
				role="presentation" />
			<span class="_ws_logo_title">Word</span><span class="_ws_logo_title2">smyth</span>
		</div>
		<outbound-link
			v-if="!userContext || !userContext.classCode"
			href="https://www.wordsmyth.net/"
			target="_blank"
			data-outbound-link="WS_MODAL_WORDSMYTH">
			<span class="_ws_pre_title">Powered by</span>
			<img
				:src="logoSrc"
				alt="WordSmyth Logo"
				role="presentation" />
			<span class="_ws_logo_title">Word</span><span class="_ws_logo_title2">smyth</span>
		</outbound-link>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';

	.wordsmyth-powered-by {
		// position: absolute;
		// bottom: .4rem;
		// right: .8rem;
		text-align: right;
		background-color: white;

		font-family: Verdana, Geneva, Arial, Helvetica, sans-serif;
		font-size: 0;

		span {
			font-size: 1.18rem;
		}

		._ws_pre_title {
			color: $c-slate-dark;
			padding-right: 10px;
		}

		._ws_logo_title,
		._ws_logo_title2 {
			color: $c-slate-dark;
			padding-left: 0;
		}
		._ws_logo_title {
			font-weight: bold;
		}
		img {
			vertical-align: -24%;
		}
	}
</style>
